module.exports = __webpack_public_path__ + "6e8624faf3992a9f2ede5c7a66d84c32.pdf";